import { PresetEditor as PresetEditorModule } from '@modules/presets';
import { Flex } from 'antd';
import styles from './presets.module.scss';

export const PresetEditor = () => (
  <Flex className={styles.root} align="center" justify="center">
    <PresetEditorModule />
  </Flex>
);
